import { useContext } from 'react';
import { PegelContext } from '../contexts/PegelContext';

// ----------------------------------------------------------------------

const usePegel = () => useContext(PegelContext);

export default usePegel;
